import * as NotificationsActions from '../actions/notification.actions';
import * as AuthActions from '../../auth/actions/auth.actions';

// App State
export interface State {
  projectView: boolean;
  userNotification: any | null;
}

// Initial State
export const initialState: State = {
  projectView: false,
  userNotification: null
};

// Export Reducer
export function reducer(state = initialState, action: NotificationsActions.Actions | AuthActions.LogoutSuccess): State {
  switch (action.type) {

    case NotificationsActions.GET_USER_NOTIFICATIONS_SUCCESS:
       return { ...initialState, userNotification: action.payload };
    // User Logout
    case AuthActions.LOGOUT_SUCCESS:
      return initialState;

    // Default
    default:
      return state;

  }
}



// WEBPACK FOOTER //
// ./src/app/core/reducers/notification.reducer.ts